/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Placeholders_EnterInputs */

const en_placeholders_enter = /** @type {(inputs: Placeholders_EnterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Enter {name}" |
*
* @param {Placeholders_EnterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const placeholders_enter = /** @type {((inputs: Placeholders_EnterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_EnterInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_enter(inputs)
});